import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ConfiguracaoEmail} from "../models/configuracao-email";
import {Email} from "../models/email";

@Injectable({
  providedIn: 'root'
})
export class ComunicacaoService {
  private handlerErro: HandlerError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`ComunicacaoService`);
  }

  baseUrl = environment.apiUrl;

  selecionarListaConfiguracoes(): Observable<BaseResponse<ConfiguracaoEmail[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ConfiguracaoEmail[]>>(`${this.baseUrl}/Comunicacao/Configuracoes`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }


  selecionarEmailsPorConfigPorOrigemPorUsuario(configId: number): Observable<BaseResponse<Email> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<Email>>(`${this.baseUrl}/Comunicacao/Email/PorConfiguracaoPorOrigemPorUsuario/` + configId)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarEmailsPorOrigemPorUsuario')));
  }

  selecionarListaConfiguracoesAtivos(): Observable<BaseResponse<ConfiguracaoEmail[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ConfiguracaoEmail[]>>(`${this.baseUrl}/Comunicacao/Configuracoes/Ativos`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  adicionarConfiguracao(request: ConfiguracaoEmail): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Comunicacao/Configuracoes`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  removerConfiguracao(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Comunicacao/Configuracoes/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('remover')));
  }

}
